// src/hooks/usePrefersReducedMotion.ts
import { useState, useEffect } from 'react';

export const usePrefersReducedMotion = (): boolean => {
  const [prefersReducedMotion, setPrefersReducedMotion] = useState(false);

  useEffect(() => {
    const mediaQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
    setPrefersReducedMotion(mediaQuery.matches);

    const handleChange = (event: MediaQueryListEvent) => {
      setPrefersReducedMotion(event.matches);
      console.log('♿ Reduced motion preference changed:', event.matches);
    };

    mediaQuery.addEventListener('change', handleChange);

    if (mediaQuery.matches) {
      console.log('♿ Reduced motion mode: ENABLED');
    }

    return () => mediaQuery.removeEventListener('change', handleChange);
  }, []);

  return prefersReducedMotion;
};

